import { useMemo, useState, useCallback } from "react";
import { useTable, usePagination, useFlexLayout } from "react-table";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import "./Table.css";
import CustomButton from "../../ui/button/Button";
import Buscar from "../../assets/img/svg/buscar.svg";
import Anadir from "../../assets/img/svg/anadir.svg";
import Personas from "../../assets/img/svg/providers/personas.svg";
import ContainerModal from "../modal/Modal";
import { useNavigate } from "react-router-dom";

const TableC = ({
  data,
  setData,
  columns,
  rowsPerPage,
  url,
  fields,
  perfiles,
  dataOriginal,
  isOn,
  setIsOn,
  width,
  height,
  fetchData,
  section,
  title,
  navigateBTNew = "/proveedores/nuevo",
  customSelectComponent,
  installers = false,
  setFilteredBase,
  dashboard,
  specialties,
  projects = false,
  clients = false,
  workCenters = false,
}) => {
  const memoizedData = useMemo(() => data, [data]);
  const memoizedColumns = useMemo(() => columns, [columns]);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    gotoPage,
    pageCount,
    state: { pageIndex },
  } = useTable(
    {
      columns: memoizedColumns,
      data: memoizedData,
      initialState: { pageSize: rowsPerPage || 5 },
    },
    useFlexLayout,
    usePagination
  );
  const [showModal, setShowModal] = useState(false);
  const handleOpenModal = useCallback(() => setShowModal(true), []);
  const handleCloseModal = useCallback(() => setShowModal(false), []);
  let initial = fields.reduce((acc, field) => {
    acc[field.name] = null; // Valores iniciales nulos
    return acc;
  }, {});

  if (fields.some((f) => f.name === "buscarInhabilitados")) {
    initial = {
      ...initial,
      buscarInhabilitados: false,
    };
  }

  const [busqueda, setBusqueda] = useState(initial);
  const navigate = useNavigate();

  const handlePageChange = useCallback(
    (event, value) => {
      gotoPage(value - 1);
    },
    [gotoPage]
  );

  return (
    <>
      <div className="d-flex flex-row">
        {/* Botón para abrir el modal */}
        <div className="d-flex flex-row" style={{ marginRight: "0.5rem" }}>
          {(section === "instaladores" ||
            section === "proveedores" ||
            section === "proyectos" ||
            section === "clientes" ||
            section === "centros-de-carga") && (
            <>
              <h1 className="table-title">{title}</h1>
              <div className="table-title-space" />
            </>
          )}

          {section !== "instaladores" &&
            section !== "clientes" &&
            section !== "proyectos" &&
            section !== "centros-de-carga" && (
              <CustomButton
                background={"#FFFFFF"}
                width={"76px"}
                height={"31px"}
                fontSize={"14px"}
                color={"#223D51"}
                text={"Filtro"}
                fontWeight={700}
                fontStyle={"normal"}
                border={"0.5px solid #C3C3C3"}
                icon={true}
                src={Buscar}
                iconW={"12px"}
                iconM={"5px"}
                onClick={handleOpenModal}
              />
            )}
        </div>
        {fetchData && (
          <div style={{ marginRight: "0.5rem" }}>
            <CustomButton
              background={"#223D51"}
              width={"180px"}
              height={"31px"}
              fontSize={"12px"}
              color={"#FFFFFF"}
              text={"Ver todos los proveedores"}
              fontWeight={700}
              fontStyle={"normal"}
              border={"0.5px solid #C3C3C3"}
              icon={true}
              src={Personas}
              iconW={"12px"}
              iconM={"5px"}
              onClick={() => navigate("/proveedores/todos")}
            />
          </div>
        )}
        {projects && (
          <div style={{ marginRight: "0.5rem" }}>
            <CustomButton
              background={"#223D51"}
              width={"180px"}
              height={"31px"}
              fontSize={"12px"}
              color={"#FFFFFF"}
              text={"Ver todos los proyectos"}
              fontWeight={700}
              fontStyle={"normal"}
              border={"0.5px solid #C3C3C3"}
              icon={true}
              src={Personas}
              iconW={"12px"}
              iconM={"5px"}
              onClick={() => navigate("/proyectos/todos")}
            />
          </div>
        )}
        {clients && dashboard && (
          <div style={{ marginRight: "0.5rem" }}>
            <CustomButton
              background={"#223D51"}
              width={"120px"}
              height={"31px"}
              fontSize={"12px"}
              color={"#FFFFFF"}
              text={"Ver todos"}
              fontWeight={700}
              fontStyle={"normal"}
              border={"0.5px solid #C3C3C3"}
              icon={true}
              src={Personas}
              iconW={"12px"}
              iconM={"5px"}
              onClick={() => navigate("/proyectos/clientes")}
            />
          </div>
        )}
        {workCenters && dashboard && (
          <div style={{ marginRight: "0.5rem" }}>
            <CustomButton
              background={"#223D51"}
              width={"120px"}
              height={"31px"}
              fontSize={"12px"}
              color={"#FFFFFF"}
              text={"Ver todos"}
              fontWeight={700}
              fontStyle={"normal"}
              border={"0.5px solid #C3C3C3"}
              icon={true}
              src={Personas}
              iconW={"12px"}
              iconM={"5px"}
              onClick={() => navigate("/proyectos/centros")}
            />
          </div>
        )}
        {section !== "instaladores" &&
          title !== "Documentos instaladores" &&
          !workCenters && (
            <div>
              <CustomButton
                background={"#62C776"}
                width={"126px"}
                height={"31px"}
                fontSize={"14px"}
                color={"#FFFFFF"}
                text={"Añadir nuevo"}
                fontWeight={700}
                fontStyle={"normal"}
                border={0}
                icon={true}
                src={Anadir}
                iconW={"12px"}
                iconM={"5px"}
                onClick={() => navigate(navigateBTNew)}
              />
            </div>
          )}
        {installers && (
          <div style={{ marginRight: "0.5rem" }}>
            <CustomButton
              background={"#223D51"}
              width={"120px"}
              height={"31px"}
              fontSize={"12px"}
              color={"#FFFFFF"}
              text={"Ver todos"}
              fontWeight={700}
              fontStyle={"normal"}
              border={"0.5px solid #C3C3C3"}
              icon={true}
              src={Personas}
              iconW={"12px"}
              iconM={"5px"}
              onClick={() => navigate("/proveedores/instaladores")}
            />
          </div>
        )}
        <div className="d-flex flex-row">
          {/* Renderiza CustomSelect si se pasa como prop */}
          {customSelectComponent && (
            <div style={{ marginRight: "10px" }}>{customSelectComponent}</div>
          )}
        </div>
      </div>

      {/* Modal */}
      <ContainerModal
        showModal={showModal}
        handleCloseModal={handleCloseModal}
        setData={setData}
        url={url}
        fields={fields}
        busqueda={busqueda}
        setBusqueda={setBusqueda}
        initial={initial}
        perfiles={perfiles}
        dataOriginal={dataOriginal}
        isOn={isOn}
        setIsOn={setIsOn}
        width={width}
        height={height}
        setFilteredBase={setFilteredBase}
        specialties={specialties}
      />

      <div className="table-container">
        <table {...getTableProps()} className="custom-table">
          <thead>
            {headerGroups.map((headerGroup) => {
              const { key, ...headerProps } = headerGroup.getHeaderGroupProps();
              return (
                <tr key={key} {...headerProps}>
                  {headerGroup.headers.map((column) => (
                    <th
                      {...column.getHeaderProps()}
                      key={column.id}
                      className={
                        [
                          "Contrato",
                          "INE",
                          "IMSS",
                          "Cert. Médico",
                          "DC3",
                          "REPSE",
                          "Estatus",
                        ].includes(column.Header)
                          ? "center-header"
                          : ""
                      }
                    >
                      {column.render("Header")}
                    </th>
                  ))}
                </tr>
              );
            })}
          </thead>

          <tbody {...getTableBodyProps()}>
            {page.map((row) => {
              prepareRow(row);

              return (
                <tr
                  {...row.getRowProps()}
                  key={`row-${row.original?.id || row.index}`}
                >
                  {row.cells.map((cell) => {
                    if (cell.column.id === "action") {
                      return (
                        <td
                          {...cell.getCellProps()}
                          key={`${row.original?.id}-${cell.column.id}`}
                        ></td>
                      );
                    }
                    return (
                      <td
                        {...cell.getCellProps()}
                        key={`${row.original?.id}-${cell.column.id}`}
                      >
                        {cell.render("Cell")}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
        <div>
          <p
            style={{
              color: "#223D51",
              textAlign: "left",
              fontFamily: "Nunito",
              marginLeft: "1rem",
              fontSize: "14px",
            }}
          >
            Total: {data?.length}
          </p>
        </div>

        <Stack spacing={2}>
          <Pagination
            count={pageCount}
            page={pageIndex + 1}
            shape="rounded"
            color="primary"
            hideNextButton={false}
            hidePrevButton={false}
            siblingCount={dashboard ? 1 : 2} // Similar a 'marginPagesDisplayed', ajusta el número de páginas visibles alrededor de la página actual
            boundaryCount={dashboard ? 1 : 2} // Similar a 'pageRangeDisplayed', ajusta el número de páginas al principio y al final
            className="pagination"
            onChange={handlePageChange}
          />
        </Stack>
      </div>
    </>
  );
};

export default TableC;
